import { render, staticRenderFns } from "./MethodologicalStrategyTable.vue?vue&type=template&id=7aaba4a8&scoped=true"
import script from "./MethodologicalStrategyTable.vue?vue&type=script&lang=js"
export * from "./MethodologicalStrategyTable.vue?vue&type=script&lang=js"
import style0 from "./MethodologicalStrategyTable.vue?vue&type=style&index=0&id=7aaba4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaba4a8",
  null
  
)

export default component.exports